"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EUDomainNames_1 = require("./EUDomainNames");
var GCCDomainPatterns_1 = require("./GCCDomainPatterns");
var retrieveCollectorUri = function (orgUrl) {
    var defaultCollectorUri = "https://browser.pipe.aria.microsoft.com/Collector/3.0/";
    var EUCollectorUri = "https://eu-mobile.events.data.microsoft.com/Collector/3.0/";
    var GCCCollectorUri = "https://tb.pipe.aria.microsoft.com/Collector/3.0/";
    var url = orgUrl;
    if (orgUrl.endsWith("/")) {
        url = orgUrl.replace("/", "");
    }
    for (var i = 0; i < EUDomainNames_1.default.length; i++) {
        if (url.endsWith(EUDomainNames_1.default[i])) {
            return EUCollectorUri;
        }
    }
    for (var i = 0; i < GCCDomainPatterns_1.default.length; i++) {
        if (url.includes(GCCDomainPatterns_1.default[i])) {
            return GCCCollectorUri;
        }
    }
    return defaultCollectorUri;
};
exports.default = retrieveCollectorUri;
//# sourceMappingURL=retrieveCollectorUri.js.map